import Create from "./Create";
import Stats from "./Stats";
import Table from "./Table";

function Organisations() {
  return (
    <div>
        <Stats />
        <Table />
        <Create />
    </div>
  );
}

export default Organisations;
